import {
  getGridSingleSelectOperators,
  GridFilterInputMultipleSingleSelect,
  GridFilterInputValue,
  type GridFilterItem,
} from "@mui/x-data-grid-premium";
import {
  BetweenComponent,
  PrioritizedComponent,
} from "./ESDocFilterComponents";

const doNothing = () => {
  return null;
};

export const filters = {
  noteTitle: [
    {
      label: "contains",
      value: "contains",
      getApplyFilterFn: doNothing,
      InputComponent: GridFilterInputValue,
    },
    {
      label: "does not contain",
      value: "doesNotContain",
      getApplyFilterFn: doNothing,
      InputComponent: GridFilterInputValue,
    },
    {
      label: "equals",
      value: "equals",
      getApplyFilterFn: doNothing,
      InputComponent: GridFilterInputValue,
    },
    {
      label: "does not equal",
      value: "doesNotEqual",
      getApplyFilterFn: doNothing,
      InputComponent: GridFilterInputValue,
    },
  ],
  diffDays: [
    {
      label: "=",
      value: "=",
      getApplyFilterFn: doNothing,
      InputComponent: GridFilterInputValue,
    },
    {
      label: ">",
      value: ">",
      getApplyFilterFn: doNothing,
      InputComponent: GridFilterInputValue,
    },
    {
      label: "<",
      value: "<",
      getApplyFilterFn: doNothing,
      InputComponent: GridFilterInputValue,
    },
    {
      label: ">=",
      value: ">=",
      getApplyFilterFn: doNothing,
      InputComponent: GridFilterInputValue,
    },
    {
      label: "<=",
      value: "<=",
      getApplyFilterFn: doNothing,
      InputComponent: GridFilterInputValue,
    },
    {
      label: "between",
      value: "between",
      getApplyFilterFn: doNothing,
      InputComponent: BetweenComponent,
      InputComponentProps: {
        sx: { paddingBottom: "10px" },
      },
    },
  ],
  noteType: [
    ...getGridSingleSelectOperators(),
    {
      label: "is not any of",
      value: "isNotAnyOf",
      getApplyFilterFn: doNothing,
      InputComponent: GridFilterInputMultipleSingleSelect,
    },
  ],
  notePreview: [
    {
      label: "contains",
      value: "contains",
      getApplyFilterFn: doNothing,
      InputComponent: GridFilterInputValue,
    },
    {
      label: "does not contain",
      value: "doesNotContain",
      getApplyFilterFn: doNothing,
      InputComponent: GridFilterInputValue,
    },
  ],
  keywordScore: [
    {
      value: "isPrioritized",
      label: "is prioritized",
      getApplyFilterFn: doNothing,
      InputComponent: PrioritizedComponent,
    },
  ],
};

// "Content" column in the table UI maps to preview text,
// but we want to filter server side on the full text
export function remapNoteFilters(filter_items: GridFilterItem[]) {
  // Deep clone the filter_items so the underlying filters are not changed
  const remapped_filter_items = structuredClone(filter_items);

  if (remapped_filter_items) {
    for (const item of remapped_filter_items) {
      if (item["field"] === "notePreview") {
        item["field"] = "noteText";
      }
    }
  }
  return remapped_filter_items;
}
